export const platformAdminIdentityCustomFields = {
  columns: {
    fieldKey: "字段键",
    label: "字段名称",
    dataType: "字段类型",
    required: "必填",
    visibility: "可见性",
    editability: "可编辑性",
    sortOrder: "排序",
  },
  values: {
    archived: "已归档",
    visible: "可见",
    hidden: "隐藏",
    editable: "可编辑",
    readonly: "只读",
  },
  dataTypes: {
    text: "单行文本",
    textarea: "多行文本",
    number: "数字",
    select: "单选",
    boolean: "布尔",
    date: "日期",
  },
  actions: {
    createDefinition: "新建字段定义",
    userValues: "用户自定义字段",
  },
  forms: {
    createTitle: "新建用户自定义字段",
    editTitle: "编辑用户自定义字段 · {name}",
    fieldKey: "字段键",
    label: "字段名称",
    dataType: "字段类型",
    required: "必填",
    visibility: "可见性",
    editability: "可编辑性",
    sortOrder: "排序",
    options: "选项",
    optionsText: "选项（每行一个）",
    requiredField: "请输入 {label}",
    requiredFieldKey: "请输入字段键",
    requiredLabel: "请输入字段名称",
    requiredDataType: "请选择字段类型",
    requiredOptions: "请输入选项，每行一个",
  },
  drawers: {
    userValues: "用户自定义字段 · {name}",
    userValuesShort: "用户自定义字段",
  },
  alerts: {
    userValues:
      "自定义字段值写入统一身份中心 user_profiles.custom_fields_json，业务应用按需读取 identity 主数据。",
  },
  confirms: {
    archiveTitle: "归档字段定义",
  },
  messages: {
    loadUserValuesFailed: "加载用户自定义字段失败",
    noTargetUser: "未选择目标用户",
    valuesSaved: "用户自定义字段已保存",
    valuesSaveFailed: "保存用户自定义字段失败",
    definitionCreated: "字段定义已创建",
    definitionCreateFailed: "字段定义创建失败",
    definitionUpdated: "字段定义已更新",
    definitionUpdateFailed: "字段定义更新失败",
    definitionArchived: "字段定义已归档",
    archivedReadonly: "归档字段定义为审计保留终态，不可编辑或恢复",
    definitionArchiveFailed: "字段定义归档失败",
    noArchivableDefinitions: "当前选择中没有可归档的字段定义",
    batchDefinitionArchived: "已归档 {count} 个字段定义",
    batchDefinitionArchivePartialFailed: "仍有 {count} 个字段定义归档失败",
  },
} as const;
